import numeral from "numeral";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import { cn, getPathURL } from "../../../utils/useFunctions";
import { PdfCard, PdfCardGray, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_12,
  STYLE_PDF_TEXT_MEDIUM_BLUE_11,
} from "../styles/pdf.style";
import {
  options_education_rank,
  options_under_education,
} from "../../education/functions/options";

function IncomeFuturePDF({ page, datalist = [] }) {
  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="แผนอนาคต"
        icon="/images/personal.svg"
        classNameIcon="w-[24px] h-[27px]"
      />
      {/* แผนอนาคต */}
      <PdfCard className={"flex flex-col space-y-3"} title={"รายรับในอนาคต"}>
        {datalist?.map((item, index) => {
          return (
            <PdfCardWhite
              key={index}
              className={cn("flex flex-col space-y-2 px-3")}
            >
              <div className={cn(STYLE_PDF_TEXT_MEDIUM_12, "text-left")}>
                {item?.title}
              </div>
              <PdfLine />
              <div className="flex items-center space-x-2">
                <div>
                  <img src={`/images/${item.icon}`} />
                </div>
                <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                  {item?.label}
                </div>
              </div>
              <PdfCardGray className={cn("px-2")}>
                <div className="flex justify-between space-y-1">
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                    {"คาดการณ์ไว้อีก"}
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                      "flex space-x-2"
                    )}
                  >
                    {`${item?.year} ปี`}
                  </div>
                </div>
                {!item?.is_rent && (
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                      {"จำนวนเงิน"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2"
                      )}
                    >
                      {`${numeral(item?.amount).format("0,0")} บาท`}
                    </div>
                  </div>
                )}
                {item?.is_rent && (
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                      {"ระยะเวลาที่จะมีรายรับ (ปี)"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2"
                      )}
                    >
                      {`${numeral(item?.year_rent).format("0,0")} ปี`}
                    </div>
                  </div>
                )}
                {item?.is_rent && (
                  <div className="flex justify-between space-y-1">
                    <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                      {"จำนวนเงินที่ได้ต่อปี"}
                    </div>
                    <div
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_11,
                        "flex space-x-2"
                      )}
                    >
                      {`${numeral(item?.amount_perYear).format("0,0")} บาท`}
                    </div>
                  </div>
                )}
              </PdfCardGray>
            </PdfCardWhite>
          );
        })}
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default IncomeFuturePDF;
